// -----------------------------
// グローバル変数はここで定義しておく
// -----------------------------
let scrollAmount = 0;
let indexCheck = false;
let kvHeight = "";

// -----------------------------
// 関数群
// -----------------------------

//js処理用メディアクエリ
function media() {
  let mediaFlg;
  const width = window.innerWidth;
  if (width > 1024) {
    mediaFlg = "pc";
  } else if (width >= 600) {
    mediaFlg = "tablet";
  } else if (width <= 599) {
    mediaFlg = "sp";
  }
  return mediaFlg;
}

/* 要素を取得する */
function getElements(elem) {
  let targetElement = document.querySelectorAll(elem);
  targetElement = [...targetElement];
  return targetElement;
}

/* 第一引数：イベントトリガー要素 第二引数：イベントタイプ 第三引数：実行したい関数名 */
function eventRunner(target, handle, callback) {
  if (document.querySelector(target) != null) {
    let eventTargetElement = getElements(target);
    eventTargetElement.forEach(function (elem, index) {
      if (handle === "none") {
        callback(elem);
      } else {
        elem.addEventListener(handle, callback);
      }
    });
  }
}

//スムーススクロール
if (document.querySelector(".scrollTrigger") != null) {
  //サイト読み込み時にスクロールターゲットの座標を設定
  window.addEventListener("load", function () {
    scrollAction();
  });
  //リサイズ時にスクロールターゲットの座標を再設定
  window.addEventListener("resize", function () {
    scrollAction();
  });
}

function scrollAction() {
  const headerHeight = document.querySelector(".header").clientHeight;
  const scrollTrigger = document.querySelectorAll(".scrollTrigger");
  scrollTrigger.forEach(function (elem, index) {
    const scrollTargetAttr = elem.getAttribute("href");
    const scrollTargetElm = document.querySelector(scrollTargetAttr);
    const rect = scrollTargetElm.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollTargetTop = rect.top + scrollTop;

    elem.addEventListener("click", function (event) {
      event.preventDefault();
      window.scrollTo({
        top: scrollTargetTop - headerHeight,
        left: 0,
        behavior: "smooth",
      });
    });
  });
}

// スクロールでヘッダーとサイドバーを表示/非表示
function toggleHeaderAndSidebar(val, distance, identify = [false, 0]) {
  //console.log(val);

  if (val < document.documentElement.scrollTop && val > distance) {
    document.querySelector(".header").classList.add("is-hide");
  } else {
    document.querySelector(".header").classList.remove("is-hide");
  }
  if (
    identify[0] === true &&
    identify[1] > document.documentElement.scrollTop
  ) {
    document.querySelector("body").classList.add("has-transform-header");
  } else {
    document.querySelector("body").classList.remove("has-transform-header");
  }
  val = document.documentElement.scrollTop;
  return val;
}

// ヘッダーメガメニュー
function megamenuInit(elm) {
  const megaMenuCont = elm.querySelector(".header-nav__submenu");
  if (media() === "pc") {
    elm.addEventListener("mouseenter", (e) => {
      megaMenuCont.classList.add("is-show");
    });

    elm.addEventListener("mouseleave", (e) => {
      megaMenuCont.classList.remove("is-show");
    });
  } else {
    elm.addEventListener("click", (e) => {
      megaMenuCont.classList.toggle("is-show");
    });
  }
}

function indexParallax(targetElm) {
  
  gsap.from('.index-cermon h2,.index-cermon p', {
    duration: 1,
    autoAlpha: 0,
    y: 100,
    scrollTrigger: {
      trigger: '.index-cermon h2,.index-cermon p',
      markers: false,
      scrub: 3,
      start: "370% 100%",
      end: "50% 0%",
    },
  });
  ScrollTrigger.create({
    trigger: '.index-cermon',
    pin: true,
    markers: false
  });
}

// -----------------------------
// イベント系
// -----------------------------

// DOM読み込まれたら発火
window.addEventListener("DOMContentLoaded", function () {
  // ヘッダーメガメニュー
  eventRunner(".has-submenu", "none", megamenuInit);

  indexCheck = document
    .querySelector("body")
    .classList.contains("has-transform-header");
  if (indexCheck) {
    kvHeight = document.querySelector(
      ".js-trigger-transform-header"
    ).clientHeight;
  }

  const cermon = document.querySelector('.index-cermon');
  if(cermon !== null) {
    indexParallax(cermon);
  }
});

// リサイズ時に発火
window.addEventListener("resize", function () {});

// スクロール時に発火
window.addEventListener("scroll", function () {
  // スクロールでヘッダーとサイドバーを表示/非表示
  scrollAmount = toggleHeaderAndSidebar(scrollAmount, 200, [
    indexCheck,
    kvHeight,
  ]);
});

// -----------------------------
// その他
// -----------------------------

//スクロールでアニメーションクラスを追加
if (document.querySelector(".anm") != null) {
  const anm = document.querySelectorAll(".anm");
  const options = {
    root: null,
    rootMargin: "-4%",
    threshold: [0],
  };
  const observe = new IntersectionObserver(addAnimation, options);
  anm.forEach(function (elem, index) {
    observe.observe(elem);
  });
  function addAnimation(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show");
      } else {
        // entry.target.classList.remove("is-show");
      }
    });
  }
}

// アコーディオンパネル
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const isRunning = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const isOpend = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (element.dataset.animStatus === isRunning) {
        return;
      }
      if (element.open) {
        element.classList.toggle(isOpend);
        const closingAnim = content.animate(
          closingAnimKeyframes(content),
          animTiming
        );

        element.dataset.animStatus = isRunning;
        closingAnim.onfinish = () => {
          element.removeAttribute("open");
          element.dataset.animStatus = "";
        };
      } else {
        element.setAttribute("open", "true");
        element.classList.toggle(isOpend);

        const openingAnim = content.animate(
          openingAnimKeyframes(content),
          animTiming
        );
        element.dataset.animStatus = isRunning;
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
};

/* アニメーションの時間とイージング */
const animTiming = {
  duration: 400,
  easing: "ease-out",
};

/*　アコーディオンを閉じるときのキーフレーム　*/
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

/* アコーディオンを開くときのキーフレーム */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
];

